import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

export const CustomerEdit = (props: any) => {
  const propsObj: any = { ...props };

  if (propsObj.permissions) {
    const resourcename = `/${props.resource}`;
    const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
    if (myPermissions.length > 0) {
      const p = myPermissions[0];
      propsObj.hasList = p.View === 1;
      propsObj.hasShow = p.View === 1;
      propsObj.hasEdit = p.Edit === 1;
      propsObj.hasDelete = p.Delete === 1;
      propsObj.hasCreate = p.Create === 1;
      propsObj.hasExport = p.Export === 1;
    }
  }

  return (
    <React.Fragment>
      <Edit title="Edit Customer" {...propsObj} undoable={false}>
        <SimpleForm
          warnWhenUnsavedChanges
          redirect="list"
          toolbar={<FormToolbar {...propsObj} />}
          variant="outlined"
        >
          <TextInput source="code" label="Code" fullWidth validate={[required()]} />
          <TextInput source="customerName" label="Customer Name" fullWidth validate={[required()]} />
          {/* <ReferenceInput
            label="User"
            source="userId"
            reference="users"
            fullWidth
            disabled={true}
          >
            <AutocompleteInput optionText="userName" fullWidth resettable disabled={true} />
          </ReferenceInput> */}
          <TextInput source="mobileNo" label="Mobile" fullWidth />
          <TextInput source="state" label="State" fullWidth />
          <TextInput source="address1" label="Address 1" fullWidth />
          <TextInput source="address2" label="Address 2" fullWidth />
          <TextInput source="address3" label="Address 3" fullWidth />
          <TextInput source="pincode" label="Pincode" fullWidth />
        </SimpleForm>
      </Edit>
    </React.Fragment>
  );
};
